(() => {
  'use strict';

  const controllers = new WeakMap();
  const originalStockText = new WeakMap();
  const activeSelector = '.essential-preorder-container-active';

  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };

  function sync(component) {
    const form = component.querySelector('form[action*="/cart/add"]');
    const deliveryInput = form?.querySelector('[data-preorder-delivery]');
    if (!deliveryInput) return;

    let variant = null;
    try {
      const selected = component.querySelector('variant-selects [data-selected-variant]');
      if (selected) {
        variant = JSON.parse(selected.textContent);
      } else {
        const product = JSON.parse(component.querySelector('[data-product-json]')?.textContent || 'null');
        if (product?.variants?.length === 1) variant = product.variants[0];
      }
    } catch {
      // A section can be between variant renders; leave the extra property disabled.
    }

    const active = form.querySelector(activeSelector);
    const campaignId = form.querySelector('[name="properties[_essential_preorder_campaign_id]"]')?.value;
    const planId = form.querySelector('[name="selling_plan"]')?.value;
    const variantId = form.querySelector('[name="id"]')?.value;
    const planMatches = variant?.selling_plan_allocations?.some(
      (allocation) => String(allocation.selling_plan_id) === planId
    );
    const isPreorder = Boolean(
      variant?.available && String(variant.id) === variantId && planMatches && campaignId &&
      active?.querySelector('[data-essential-preorder-element="button"]')
    );
    const message = isPreorder
      ? active.querySelector('[data-essential-preorder-element="message"]')?.textContent.trim() ||
        active.querySelector('[data-essential-preorder-element="button-text"]')?.textContent.trim() || ''
      : '';

    deliveryInput.disabled = !message;
    if (deliveryInput.value !== message) deliveryInput.value = message;

    const wrapper = component.querySelector('[data-remaining-wrapper]');
    if (!wrapper) return;
    if (wrapper.hasAttribute('data-preorder-active') !== Boolean(message)) {
      wrapper.toggleAttribute('data-preorder-active', Boolean(message));
    }
    setText(wrapper.querySelector('.variant__countdown--preorder'), message);

    const standardStatus = [...wrapper.children].find(
      (element) => !element.matches('.variant__countdown--preorder') && getComputedStyle(element).display !== 'none'
    );
    const statusText = message || standardStatus?.textContent.trim() || '';
    component.querySelectorAll('[data-variant-stock]').forEach((item) => {
      const status = item.querySelector('[data-variant-stock-status]');
      if (!status) return;
      if (!originalStockText.has(status)) originalStockText.set(status, status.textContent);
      const selected = item.dataset.variantId === variantId;
      if (item.hasAttribute('data-selected') !== selected) item.toggleAttribute('data-selected', selected);
      setText(status, selected && statusText ? statusText : originalStockText.get(status));
    });
    if (statusText) {
      const title = variant?.public_title || variant?.title || '';
      setText(component.querySelector('[data-variant-accessibility-status]'), title ? `${title}: ${statusText}` : statusText);
    }
  }

  function initialize(component) {
    if (controllers.has(component)) {
      controllers.get(component)();
      return;
    }
    let frame = null;
    const schedule = () => {
      if (frame !== null) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        if (component.isConnected) sync(component);
      });
    };
    controllers.set(component, schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(component, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'value', 'data-bike-stock-ready'],
    });
    component.addEventListener('click', () => sync(component), true);
    component.addEventListener('submit', () => sync(component), true);
    component.addEventListener('change', schedule);
    schedule();
  }

  function scan(root = document) {
    if (root.matches?.('product-info')) initialize(root);
    root.querySelectorAll('product-info').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  document.addEventListener('theme:product-info:loaded', (event) => scan(event.target));
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
